import React, { useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import * as ruleService from "../../ruleService";

const emptyState = {
    matched: false,
    heading: "",
    fields: []
};

const skeletonBlocks = [
    { labelWidth: 72, height: 42 },
    { labelWidth: 118, height: 88 },
    { labelWidth: 96, height: 104 },
    { labelWidth: 132, height: 76 }
];

function CisInfoSkeleton() {
    return (
        <div className="addrules-cis-skeleton-v2" aria-hidden="true">
            {skeletonBlocks.map((block, index) => (
                <div className="addrules-cis-skeleton-field-v2" key={index}>
                    <Skeleton variant="text" width={block.labelWidth} height={18} />
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={block.height}
                        className="addrules-cis-skeleton-control-v2 oct_skeleton-radius-4"
                    />
                </div>
            ))}
        </div>
    );
}

function CisInfoTab({ ruleId }) {
    const [cisInfo, setCisInfo] = useState(emptyState);
    const [loading, setLoading] = useState(!!ruleId);

    useEffect(() => {
        let mounted = true;

        if (!ruleId) {
            setCisInfo(emptyState);
            setLoading(false);
            return undefined;
        }

        setLoading(true);

        ruleService.getCisRuleInfo(ruleId)
            .then((response) => {
                if (!mounted) {
                    return;
                }

                setCisInfo({
                    matched: !!response?.matched,
                    heading: response?.heading || "",
                    fields: Array.isArray(response?.fields) ? response.fields : []
                });
            })
            .catch(() => {
                if (!mounted) {
                    return;
                }
                setCisInfo(emptyState);
            })
            .finally(() => {
                if (mounted) {
                    setLoading(false);
                }
            });

        return () => {
            mounted = false;
        };
    }, [ruleId]);

    if (!ruleId) {
        return (
            <div className="addrules-form-group-v2">
                <label className="addrules-form-label-v2">CIS Information</label>
                <textarea
                    className="addrules-form-textarea-v2"
                    value="Save the rule first to attach CIS benchmark information."
                    disabled
                    rows="3"
                />
            </div>
        );
    }

    if (loading) {
        return (
            <div className="addrules-form-group-v2">
                <label className="addrules-form-label-v2">CIS Information</label>
                <CisInfoSkeleton />
            </div>
        );
    }

    if (!cisInfo.matched) {
        return (
            <div className="addrules-form-group-v2">
                <label className="addrules-form-label-v2">CIS Information</label>
                <textarea
                    className="addrules-form-textarea-v2"
                    value="No CIS benchmark information was found for this rule in the CIS benchmark workbook."
                    disabled
                    rows="4"
                />
            </div>
        );
    }

    return (
        <>
            <div className="addrules-form-group-v2">
                <label className="addrules-form-label-v2">Heading</label>
                <input
                    className="addrules-form-input-v2"
                    value={cisInfo.heading}
                    disabled
                    readOnly
                />
            </div>

            {cisInfo.fields.map((field, index) => (
                <div className="addrules-form-group-v2" key={`${field.label}-${index}`}>
                    <label className="addrules-form-label-v2">{field.label}</label>
                    <textarea
                        className="addrules-form-textarea-v2"
                        value={field.value}
                        disabled
                        readOnly
                        rows={Math.max(3, Math.min(8, field.value.split("\n").length + 1))}
                    />
                </div>
            ))}
        </>
    );
}

export default CisInfoTab;
